import { shopScene } from '../shopkit.js';

/** 杂货铺：本攻略屯日用 / 盐罐、餐具在这儿买。 */
export const generalDoc = shopScene({
  id: 'general',
  name: '杂货铺',
  shop: 'general',
  owner: '掌柜',
  desc: '油盐酱醋、碗筷灯烛，铺子里塞得满满当当。',
  w: 22, h: 18,
  counters: [{ gx: 8, gy: 3, len: 5, kind: 'general' }],
  props: [
    { type: 'earthenware_shelf', gx: 3, gy: 6 },
    { type: 'shelf', gx: 16, gy: 6 },
    { type: 'salt_vat', gx: 4, gy: 12 },
    { type: 'oil_vat', gx: 6, gy: 12 },
    { type: 'locked_box', gx: 17, gy: 12 },
    { type: 'waste_bin', gx: 2, gy: 15 },
  ],
  portals: [
    { to: 'main_street', gx: 11, gy: 17, spawn: [7, 9], label: '回主街' },
  ],
});

export default generalDoc;
